import { API } from "./api";

export const smsMessagingAdminApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getSmsMessagingOverview: builder.query({
      query: ({ tab = "active", page = 1, search = "" }) => ({
        url: "/admins/sms-messaging/overview",
        params: {
          tab,
          page,
          ...(search ? { search } : {}),
        },
      }),
    }),
    getAdminSmsTopupRequests: builder.query({
      query: ({ page = 1, search = "", subscription = "", status = "all", companyId }) => ({
        url: "/admins/sms-topup-requests",
        params: {
          page,
          ...(search ? { search } : {}),
          ...(subscription ? { subscription } : {}),
          ...(status && status !== "all" ? { status } : {}),
          ...(companyId ? { company_id: companyId } : {}),
        },
      }),
    }),
    approveAdminSmsTopup: builder.mutation({
      query: (body) => ({
        url: "/admins/sms-topup-requests/approve",
        method: "PUT",
        body,
      }),
    }),
    getAdminSmsHistory: builder.query({
      query: (params = {}) => ({
        url: "/admins/sms-messaging/history",
        params: {
          page: params.page || 1,
          limit: params.limit || 20,
          ...(params.company_id ? { company_id: params.company_id } : {}),
          ...(params.status && params.status !== "all"
            ? { status: params.status }
            : {}),
          ...(params.source_type && params.source_type !== "all"
            ? { source_type: params.source_type }
            : {}),
          ...(params.provider && params.provider !== "all"
            ? { provider: params.provider }
            : {}),
          ...(params.recipient_phone
            ? { recipient_phone: params.recipient_phone }
            : {}),
          ...(params.date_from ? { date_from: params.date_from } : {}),
          ...(params.date_to ? { date_to: params.date_to } : {}),
        },
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "AdminSmsHistory", id: "LIST" }],
    }),
    getAdminSmsLogById: builder.query({
      query: (logId) => ({
        url: `/admins/sms-messaging/history/${logId}`,
      }),
      transformResponse: (response) => response?.data,
      providesTags: (result, error, logId) => [
        { type: "AdminSmsHistory", id: logId },
      ],
    }),
    resendAdminSmsViaProvider: builder.mutation({
      query: ({ logId, provider }) => ({
        url: `/admins/sms-messaging/history/${logId}/resend`,
        method: "POST",
        body: { provider },
      }),
      invalidatesTags: [{ type: "AdminSmsHistory", id: "LIST" }],
    }),
    bulkResendAdminSms: builder.mutation({
      query: ({ ids, provider }) => ({
        url: `/admins/sms-messaging/history/bulk-resend`,
        method: "POST",
        body: { ids, provider },
      }),
      invalidatesTags: [{ type: "AdminSmsHistory", id: "LIST" }],
    }),
    bulkDeleteAdminSms: builder.mutation({
      query: ({ ids }) => ({
        url: `/admins/sms-messaging/history/bulk-delete`,
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: [{ type: "AdminSmsHistory", id: "LIST" }],
    }),
  }),
});

export const {
  useGetSmsMessagingOverviewQuery,
  useGetAdminSmsTopupRequestsQuery,
  useApproveAdminSmsTopupMutation,
  useGetAdminSmsHistoryQuery,
  useGetAdminSmsLogByIdQuery,
  useResendAdminSmsViaProviderMutation,
  useBulkResendAdminSmsMutation,
  useBulkDeleteAdminSmsMutation,
} = smsMessagingAdminApi;
